import { 
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  signOut as firebaseSignOut,
  sendPasswordResetEmail
} from 'firebase/auth';
import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { auth, db } from './firebase';

const googleProvider = new GoogleAuthProvider();

export const signInWithEmail = async (email, password) => {
  try {
    const result = await signInWithEmailAndPassword(auth, email, password);
    const userDoc = await getDoc(doc(db, 'users', result.user.uid));

    if (!userDoc.exists() && email !== 'jusanmagno@gmail.com') {
      await firebaseSignOut(auth);
      return {
        user: null,
        error: 'Usuário não cadastrado. Entre em contato com o administrador para solicitar acesso.'
      };
    }

    if (email === 'jusanmagno@gmail.com') {
      if (!userDoc.exists()) {
        await setDoc(doc(db, 'users', result.user.uid), {
          email: email,
          name: 'Jusan Magno',
          role: 'root',
          active: true,
          isMasterRoot: true,
          createdAt: serverTimestamp(),
          updatedAt: serverTimestamp()
        });
      }
    }

    return { user: result.user, error: null };
  } catch (error) {
    const errorMessage = error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password' || error.code === 'auth/invalid-credential'
      ? 'Credenciais inválidas. Verifique e-mail e senha.'
      : error.message;

    return { user: null, error: errorMessage };
  }
};

export const signUpWithEmail = async (email, password, userData) => {
  try {
    const result = await createUserWithEmailAndPassword(auth, email, password);
    
    // Create user document
    await setDoc(doc(db, 'users', result.user.uid), {
      email,
      ...userData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    
    return { user: result.user, error: null };
  } catch (error) {
    return { user: null, error: error.message };
  }
};

export const signInWithGoogle = async (defaultRole = 'operational') => {
  try {
    // Primeiro, verificar se o usuário já existe no sistema
    const result = await signInWithPopup(auth, googleProvider);
    const userDoc = await getDoc(doc(db, 'users', result.user.uid));

    // Se não existe documento do usuário, não permitir login
    if (!userDoc.exists()) {
      // Deslogar o usuário do Firebase Auth
      await firebaseSignOut(auth);
      return {
        user: null,
        error: 'Usuário não cadastrado. Entre em contato com o administrador para solicitar acesso.'
      };
    }

    // Usuário existe, permitir login
    return { user: result.user, error: null };
  } catch (error) {
    return { user: null, error: error.message };
  }
};

export const signOut = async () => {
  try {
    await firebaseSignOut(auth);
    return { error: null };
  } catch (error) {
    return { error: error.message };
  }
};

export const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    return { error: null };
  } catch (error) {
    return { error: error.message };
  }
};

export const getUserData = async (userId) => {
  try {
    const userDocRef = doc(db, 'users', userId);
    const userDoc = await getDoc(userDocRef);
    
    if (userDoc.exists()) {
      const data = { id: userDoc.id, ...userDoc.data() };
      return { data, error: null };
    }
    
    // Se não existe, verificar se é o email do Master Root
    const user = auth.currentUser;
    if (user && user.email === 'jusanmagno@gmail.com') {
      
      // Criar documento do Master Root
      const rootData = {
        email: user.email,
        name: user.displayName || 'Jusan Magno',
        role: 'root',
        active: true,
        isMasterRoot: true,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      };
      
      await setDoc(userDocRef, rootData);
      return { data: { id: userId, ...rootData }, error: null };
    }
    
    // Para outros usuários, retornar dados básicos para evitar erro
    if (user) {
      return { data: { id: userId, email: user.email, role: 'operational' }, error: null };
    }

    return { data: null, error: 'User document not found' };
  } catch (error) {
    console.error('❌ getUserData: Erro:', error.message);
    // If this is a Firestore permissions issue, return a lightweight fallback using the
    // authenticated user's basic info to avoid blocking the app while the rules are
    // investigated. This keeps the UI functional and avoids repeated errors in the log.
    if (error.code === 'permission-denied') {
      const user = auth.currentUser;
      if (user) {
        return { data: { id: userId, email: user.email }, error: 'permission-denied' };
      }
    }

    return { data: null, error: error.message };
  }
};

/**
 * Atualiza flag mustChangePassword do usuário
 */
export const updateUserMustChangePassword = async (userId, mustChange = false) => {
  try {
    const userDocRef = doc(db, 'users', userId);
    await setDoc(userDocRef, {
      mustChangePassword: mustChange,
      updatedAt: serverTimestamp()
    }, { merge: true });
    
    return { success: true, error: null };
  } catch (error) {
    console.error('❌ updateUserMustChangePassword: Erro:', error.message);
    return { success: false, error: error.message };
  }
};
